import { Utils } from 'versafleet-core';

const { ReduxHelper } = Utils;

const initialState = {
  billingAccounts: [],
  optionBillingAccounts: [],
};

function billingAccount(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_BILLING_ACCOUNT':
      return {
        ...state,
        billingAccounts: ReduxHelper.mergeDataWithObject(state.billingAccounts,
          action.billingAccount),
      };
    case 'RECEIVE_OPTION_BILLING_ACCOUNTS':
      return {
        ...state,
        optionBillingAccounts: action.optionBillingAccounts,
      };
    default:
      return state;
  }
}

export default billingAccount;
